<form class="h-100 w-100" [formGroup]="benefitForm"
      [ngSwitch]="benefitData['operativeMode']"
      (ngSubmit)="isValid()">
  <div class="row m-0 p-0 w-100" *ngSwitchCase="'information'">
    <div class="col-12 mb-2">
      <h4 class="text-center">
        {{benefitData && benefitData['id'] ? 'Edición ' : 'Creación '}} de información
      </h4>
    </div>
    <div class="col-12 px-xl-0 h-fit-content">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Parrafo</mat-label>
        <textarea formControlName="name" matInput placeholder="Ingresar parrafo..." type="text"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="row m-0 p-0 w-100" *ngSwitchCase="'imageParagraph'">
    <div class="col-12 mb-2">
      <h4 class="text-center">
        {{benefitData && benefitData['id'] ? 'Edición ' : 'Creación '}} de información
      </h4>
    </div>
    <div class="col-12 vs-outline-editCard h-fit-content my-2"
         *ngIf="benefitData['operativeMode'] !== 'howItWorks' && benefitData['operativeMode'] !== 'information'">
      <img class="given-img" [src]="fileImg64 || benefitData['img'] | safeDom" alt="img-benefit-slide"
           *ngIf="fileImg64 || benefitData['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload" class="custom-file-upload mt-5">
          <mat-icon>image</mat-icon>
          <span class="my-2 text-center">{{benefitData ? 'Editar ' : 'Agregar'}}
            imagen {{benefitData['isInformation'] ? 'información' : 'carrusel'}} de 72px x 72px</span>
        </label>
        <input id="file-upload" type="file" (change)="getBase64($event)"/>
      </div>
    </div>
    <div class="col-12 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Parrafo</mat-label>
        <textarea formControlName="name" matInput placeholder="Ingresar parrafo..." type="text"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="row m-0 p-0 w-100" *ngSwitchCase="'onlyImage'">
    <div class="col-12 mb-2">
      <h4 class="text-center">
        {{benefitData && benefitData['id'] ? 'Edición ' : 'Creación '}} de información
      </h4>
    </div>
    <div class="col-12 vs-outline-editCard h-fit-content my-3"
         *ngIf="benefitData['operativeMode'] !== 'howItWorks' && benefitData['operativeMode'] !== 'information'">
      <img class="given-img" [src]="fileImg64 || benefitData['img'] | safeDom" alt="img-benefit-slide"
           *ngIf="fileImg64 || benefitData['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload4" class="custom-file-upload mt-5">
          <mat-icon>image</mat-icon>
          <span class="my-2 text-center">{{benefitData ? 'Editar ' : 'Agregar'}}
            imagen {{benefitData['isInformation'] ? 'información' : 'carrusel'}} de 72px x 72px</span>
        </label>
        <input id="file-upload4" type="file" (change)="getBase64($event)"/>
      </div>
    </div>
  </div>
  <div class="row m-0 w-100" *ngSwitchCase="'benefit'">
    <div class="col-12 mb-2">
      <h4 class="text-center">
        {{benefitData && benefitData['id'] ? 'Edición ' : 'Creación '}} de Beneficio
      </h4>
    </div>
    <div class="col-12 vs-outline-editCard h-fit-content my-1"
         *ngIf="benefitData['operativeMode'] !== 'howItWorks' && benefitData['operativeMode'] !== 'information'">
      <img class="given-img" [src]="fileImg64 || benefitData['img'] | safeDom" alt="img-benefit-slide"
           *ngIf="fileImg64 || benefitData['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload1" class="custom-file-upload mt-5">
          <mat-icon>image</mat-icon>
          <span class="my-2 text-center">{{benefitData ? 'Editar ' : 'Agregar'}}
            imagen</span>
        </label>
        <input id="file-upload1" type="file" (change)="getBase64($event)"/>
      </div>
    </div>
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="title" matInput placeholder="Ingresar título..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 col-xl-6 mb-1 pl-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Subtítulo</mat-label>
        <input formControlName="subTitle" matInput placeholder="Ingresar subTitulo..." type="text">
      </mat-form-field>
    </div>
    <div *ngIf="benefitData['operativeMode'] !== 'information'"
         class="col-12 col-xl-6 mb-2 pr-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Orden</mat-label>
        <input formControlName="orderId" matInput placeholder="Ingresar lugar de orden..." type="number">
      </mat-form-field>
    </div>
  </div>
  <div class="row m-0 w-100" *ngSwitchCase="'benefitSimple'">
    <div class="col-12 mb-2">
      <h4 class="text-center">
        {{benefitData && benefitData['id'] ? 'Edición ' : 'Creación '}} de Información
      </h4>
    </div>
    <div class="col-12 vs-outline-editCard h-fit-content"
         *ngIf="benefitData['operativeMode'] !== 'howItWorks' && benefitData['operativeMode'] !== 'information'">
      <img class="given-img" [src]="fileImg64 || benefitData['img'] | safeDom" alt="img-benefit-slide"
           *ngIf="fileImg64 || benefitData['img']">
      <div class="btn-custom-file h-100 w-100">
        <label for="file-upload2" class="custom-file-upload mt-5">
          <mat-icon>image</mat-icon>
          <span class="my-2 text-center">{{benefitData ? 'Editar ' : 'Agregar'}}
            imagen</span>
        </label>
        <input id="file-upload2" type="file" (change)="getBase64($event)"/>
      </div>
    </div>
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="title" matInput placeholder="Ingresar título..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 mb-2 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Orden</mat-label>
        <input formControlName="orderId" matInput placeholder="Ingresar lugar de orden..." type="number">
      </mat-form-field>
    </div>
  </div>
  <div class="row m-0 w-100" *ngSwitchCase="'mvv'">
    <div class="col-12 mb-2">
      <h4 class="text-center">
        {{benefitData && benefitData['id'] ? 'Edición ' : 'Creación '}} de valor
      </h4>
    </div>
    <div class="col-12 my-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Descripción</mat-label>
        <input formControlName="name" matInput placeholder="Ingresar descripción..." type="text">
      </mat-form-field>
    </div>
  </div>
  <div class="row m-0 w-100" *ngSwitchCase="'howItWorks'">
    <div class="col-12 mb-2">
      <h4 class="text-center">
        {{benefitData && benefitData['id'] ? 'Edición ' : 'Creación '}} de parrafo
      </h4>
    </div>
    <div class="col-12 mb-1 mt-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Parrafo</mat-label>
        <textarea formControlName="name" matInput placeholder="Ingresar parrafo..." type="text"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="row m-0 w-100" *ngSwitchCase="'howItWorksCard'">
    <div class="col-12 mb-2">
      <h4 class="text-center">
        {{benefitData && benefitData['id'] ? 'Edición ' : 'Creación '}} de Card (¿Como funciona?)
      </h4>
    </div>
    <div class="col-12 mb-1 mt-1 px-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Título</mat-label>
        <input formControlName="title" matInput placeholder="Ingresar título..." type="text">
      </mat-form-field>
    </div>
    <div class="col-12 mb-1 pl-xl-0">
      <mat-form-field class="example-full-width w-100" appearance="outline">
        <mat-label>Subtítulo</mat-label>
        <textarea formControlName="subTitle" matInput placeholder="Ingresar subTitulo..." type="text"></textarea>
      </mat-form-field>
    </div>
  </div>

</form>
